<template>
  <v-dialog
    v-model="localIsOpen"
    persistent
    :fullscreen="fullscreen"
    :scrim="!hideOverlay"
    :scrollable="scrollable"
    :transition="transition"
    :width="width"
  >
    <component v-if="block" :is="block" :payload="payload" @loading="updateLoading" @close="close" :key="type" />
    <loading-spinner v-if="loading" />
  </v-dialog>
</template>

<script>
import { CompositeAddDialog, CompositeDeleteDialog, CompositeUpdateDialog } from '@/components/dialog/composite';
import LaborEditDialog from '@/components/dialog/labor/LaborEditDialog';
import {
  MaterialAddDialog,
  MaterialCatalogEditDialog,
  MaterialDeleteDialog,
  MaterialQuantityDialog,
  MaterialSubcontractingDialog,
} from '@/components/dialog/material';
import { PhaseAddModal, PhaseDeleteDialog } from '@/components/dialog/phase';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  name: 'AppDialog',
  components: { LoadingSpinner },
  data() {
    return {
      error: null,
      loading: false,
      localIsOpen: false,
    };
  },
  computed: {
    block() {
      switch (this.type) {
        case 'composite-add':
          return CompositeAddDialog;
        case 'composite-delete':
          return CompositeDeleteDialog;
        case 'composite-update':
          return CompositeUpdateDialog;
        case 'labor-edit':
          return LaborEditDialog;
        case 'material-add':
          return MaterialAddDialog;
        case 'material-cat-edit':
          return MaterialCatalogEditDialog;
        case 'material-delete':
          return MaterialDeleteDialog;
        case 'material-quantity':
          return MaterialQuantityDialog;
        case 'material-subcontracting':
          return MaterialSubcontractingDialog;
        case 'phase-add':
          return PhaseAddModal;
        case 'phase-delete':
          return PhaseDeleteDialog;
        default:
          return null;
      }
    },
    fullscreen() {
      return this.type === 'material-add';
    },
    hideOverlay() {
      return this.type === 'material-add';
    },
    storeIsOpen() {
      return this.$store.getters['dialog/getOpened'];
    },
    payload() {
      return this.$store.getters['dialog/getPayload'];
    },
    scrollable() {
      return this.type === 'composite-add' || this.type === 'material-add' || this.type === 'phase-add';
    },
    transition() {
      return this.type === 'material-add' ? 'dialog-bottom-transition' : null;
    },
    type() {
      return this.$store.getters['dialog/getType'];
    },
    width() {
      switch (this.type) {
        case 'composite-add':
        case 'phase-add':
          return '70%';
        case 'composite-update':
          return '60%';
        case 'composite-delete':
        case 'material-delete':
        case 'phase-delete':
          return 800;
        case 'material-add':
          return undefined;
        default:
          return 500;
      }
    },
  },
  methods: {
    close() {
      this.$store.dispatch('dialog/close');
    },
    updateLoading(isLoading = true) {
      this.loading = isLoading;
    },
    reset() {
      this.$store.dispatch('dialog/cleanUp');
    },
  },
  watch: {
    localIsOpen() {
      if (this.localIsOpen === false) {
        this.$store.dispatch('dialog/cleanUp');
      }
    },
    storeIsOpen(newVal) {
      this.localIsOpen = newVal;
    },
  },
  mounted() {
    this.localIsOpen = this.storeIsOpen;
  },
};
</script>
